// services/directusService.js

import axios from 'axios';

const DIRECTUS_API_URL = 'https://idealonline.com.tr/directus';

// Genel axios instance (isteğe bağlı)
const directusInstance = axios.create({
  baseURL: DIRECTUS_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Yardim_Alt_Baslik listesini getir (title, content, ana_baslik.title ile birlikte)
export const getYardimAltBaslikListesi = async () => {
  try {
    const response = await directusInstance.get(
      '/items/Yardim_Alt_Baslik?fields=title,content,kategoriId.title'
    );
    return response.data;
  } catch (error) {
    console.error('Yardim_Alt_Baslik verileri alınamadı:', error);
    throw error;
  }
};

// Arama_Bar_Text listesini getir
export const getAramaBarText = async () => {
  try {
    const response = await directusInstance.get('/items/Arama_Bar_Text/1?fields=content');

    return response.data;
  } catch (error) {
    console.error('Arama_Bar_Text verileri alınamadı:', error);
    throw error;
  }
};

export const getKartlarList = async () => {
  try {
    const response = await directusInstance.get('/items/Kartlar?fields=id,title,content,link');
    return response.data;
  } catch (error) {
    console.error('Kartlar verileri alınamadı:', error);
    throw error;
  }
};

export const getPdfAlerts = async () => {
  try {
    const response = await directusInstance.get('/items/Pdf_Uyarilar?fields=title,content');
    return response.data;
  } catch (error) {
    console.error('PDF uyarı mesajları alınamadı:', error);
    throw error;
  }
};

export const getBilgiKaynaklarimiz = async () => {
  try {
    const response = await directusInstance.get('/items/Bilgi_Kaynaklarimiz?fields=title,description');
    return response.data;
  } catch (error) {
    console.error('PDF uyarı mesajları alınamadı:', error);
    throw error;
  }
};

// Directus collections listesini getir
export const getCollectionsList = async () => {
  try {
    const response = await directusInstance.get('/collections');
    return response.data;
  } catch (error) {
    console.error('Collections verisi alınamadı:', error);
    throw error;
  }
};

// ----

export const getVizyonMisyon = async () => {
  try {
    const response = await directusInstance.get(
      "/items/Vizyon_Misyon?fields=mission_description,vision_description"
    );
    return response.data;
  } catch (error) {
    console.error("Vizyon & Misyon verileri alınamadı:", error);
    throw error;
  }
};

export const getMarkalarveSeriler = async () => {
  try {
    const response = await directusInstance.get(
      "/items/Markalar_ve_Seriler?fields=kutuphaneler,markalar"
    );
    return response.data;
  } catch (error) {
    console.error("Marka ve seriler verileri alınamadı:", error);
    throw error;
  }
};

export const getIkiliKart = async () => {
  try {
    const response = await directusInstance.get(
      "/items/Ikili_Kart?fields=title,description,title_2,description_2,etiketler_1,etiketler_2"
    );
    return response.data;
  } catch (error) {
    console.error("İkili kart verileri alınamadı:", error);
    throw error;
  }
};

export const getMockupText = async () => {
  try {
    const response = await directusInstance.get('/items/Mockup_Text?fields=content');
    return response.data;
  } catch (error) {
    console.error('Mockup text alınamadı:', error);
    throw error;
  }
};

export const getKazanacaklarimiz = async () => {
  try {
    const response = await directusInstance.get('/items/Kazanacaklariniz?fields=text');
    return response.data;
  } catch (error) {
    console.error('Mockup text alınamadı:', error);
    throw error;
  }
};

export const getDortluIconlar = async () => {
  try {
    const response = await directusInstance.get('/items/dortlu_iconlar?fields=title,description');
    return response.data;
  } catch (error) {
    console.error('Mockup text alınamadı:', error);
    throw error;
  }
};

export const getBasvuruSureci = async () => {
  try {
    const response = await directusInstance.get('/items/basvuru_sureci?fields=title,description');
    return response.data;
  } catch (error) {
    console.error('Mockup text alınamadı:', error);
    throw error;
  }
};

export const getSSS = async () => {
  try {
    const response = await directusInstance.get('/items/SSS?fields=title,description');
    return response.data;
  } catch (error) {
    console.error('Mockup text alınamadı:', error);
    throw error;
  }
};

